export const badgeIcon = {
  qp: "ui_quick_pick_initials",
  sgp: "ui_sgp",
  none: "",
};
